import LoggingContext from "./LoggingContext";

import Errata from "./ErrataLogger";

const LoggingProvider = ({ children }) => {
    return (
        <LoggingContext.Provider value={Errata}>
            {children}
        </LoggingContext.Provider> 
    );
}

export default LoggingProvider;